import { render, staticRenderFns } from "./ForgetNumber.vue?vue&type=template&id=65decb19&"
import script from "./ForgetNumber.vue?vue&type=script&lang=js&"
export * from "./ForgetNumber.vue?vue&type=script&lang=js&"
import style0 from "./ForgetNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports